import { usePrintShortcut } from './usePrintShortcut'
import { useSearchShortcut } from './useSearchShortcut'

export const useCreateShortcutContext = () => {
  const search = useSearchShortcut()
  const print = usePrintShortcut()

  return {
    search,
    print,
  }
}
